import React from 'react';
import { Box, Container } from '@mui/material';
// Components
import DynamicSection from '../../components/storefront/home/DynamicSection';
import RecentlyViewed from '../../components/storefront/home/RecentlyViewed';
import { useGetHome } from '../../hooks/storefront/useGetHome';
import { useTranslation } from 'react-i18next';

const Home = () => {
  const { i18n } = useTranslation();
  const { isLoading, homeData } = useGetHome();
  const sections = homeData?.sections || [];

  return (
    <Box>
      {/* Dynamic Home Sections */}
      {isLoading ? (
        // Render skeletons or loading state if needed
        <Box sx={{ p: 4, textAlign: 'center' }}>Loading...</Box>
      ) : (
        sections.map((section, index) => (
          <DynamicSection
            key={`${section.code || section.id || index}-${i18n.language}`}
            section={section}
            isLoading={false}
          />
        ))
      )}

      <Container maxWidth="lg">
        <RecentlyViewed />
      </Container>
    </Box>
  );
};

export default Home;
